import { render, staticRenderFns } from "./InvoiceRecords.vue?vue&type=template&id=698a38ba&scoped=true"
import script from "./InvoiceRecords.vue?vue&type=script&lang=js"
export * from "./InvoiceRecords.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRecords.vue?vue&type=style&index=0&id=698a38ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698a38ba",
  null
  
)

export default component.exports